import { AppSettingsService } from 'src/@dva/services/app-settings.service';
import { ChecksReport } from './models/checks-report.model';
import { ChecksReportAvailability } from './models/checks-report-availability.model';
import { HttpParams } from '@angular/common/http';
import { HttpRequestService } from 'src/@dva/services/http-request.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ChecksReportService {
  constructor(private appSettingsService: AppSettingsService, private httpRequestService: HttpRequestService) {}

  getByCompanyId(companyId: number, languageId: number) {
    const params = new HttpParams().set('languageId', languageId.toString());
    return this.httpRequestService.getQueryString<ChecksReport[]>(
      this.appSettingsService.getApiEndpointValidator(),
      `Reports/Companies/${companyId}`,
      params,
    );
  }

  isDownloadAvailable(identifier: string) {
    return this.httpRequestService.get<ChecksReportAvailability>(
      this.appSettingsService.getApiEndpointValidator(),
      `Reports/${identifier}/IsDownloadAvailable`,
    );
  }

  download(identifier: string) {
    const params = new HttpParams().set('identifier', identifier);
    return this.httpRequestService.getQueryStringBlob<Blob>(
      this.appSettingsService.getApiEndpointValidator(),
      '/Reports/Download',
      params,
    );
  }
}
